//import React from 'react';
//import './index.css';
//import App from './App';
//import * as serviceWorker from './serviceWorker';

//import { createRoot } from 'react-dom/client';
//import App from './App';

//const container = document.getElementById('root');
//const root = createRoot(container);
//root.render(<App />);

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
//serviceWorker.unregister();

import React from 'react';
import { createRoot } from 'react-dom/client';

import './index.css';
import "./styles/globals.css";
import "./styles/snowflakes.css";
import { HashRouter } from "react-router-dom";

import App from './App';
import * as serviceWorker from './serviceWorker';

const container = document.getElementById('root');
const root = createRoot(container);

root.render(
  <React.StrictMode>
    <HashRouter>
      <App />
    </HashRouter>
    
  </React.StrictMode>
);

serviceWorker.unregister();

